export default "__VITE_ASSET__fz5SAGmM__"